import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <g clipPath='url(#clip0_7036_1042)'>
            <path
                d='M9.90039 24C7.1948 24 5.84148 23.9999 4.80078 23.4902C3.8043 23.0021 2.99794 22.1957 2.50977 21.1992C2.00011 20.1585 2 18.8052 2 16.0996L2 7.90039C2 5.1948 2.00011 3.84148 2.50976 2.80078C2.99794 1.8043 3.80429 0.99794 4.80078 0.509767C5.84148 0.000112039 7.1948 1.29431e-06 9.90039 1.05778e-06L14.0996 6.90674e-07C16.8052 4.54144e-07 18.1585 0.000110962 19.1992 0.509766C20.1957 0.997938 21.0021 1.8043 21.4902 2.80078C21.9999 3.84148 22 5.1948 22 7.90039L22 16.0996C22 18.8052 21.9999 20.1585 21.4902 21.1992C21.0021 22.1957 20.1957 23.0021 19.1992 23.4902C18.1585 23.9999 16.8052 24 14.0996 24L9.90039 24Z'
                fill='currentColor'
            />
            <path d='M22 12L9 12M9 12L14.5 17.5M9 12L14.5 6.5' stroke='#FFFEFE' strokeWidth='2' />
        </g>
        <defs>
            <clipPath id='clip0_7036_1042'>
                <rect
                    width='24'
                    height='24'
                    fill='white'
                    transform='translate(24 24) rotate(180)'
                />
            </clipPath>
        </defs>
    </svg>
);

export const ExitIcon = styled(Icon)({});
